var path = '/app/invoices/templates/invoice.applied-amount.cell.html';
var html = "<input class=\"form-control align-right\" ng-class=\"'colt' + col.index\" ng-change=\"updateBalance(row.entity)\" currency ng-input=\"COL_FIELD\" ng-model=\"COL_FIELD\" editable-cell/>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;